"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlPresentedPaymentsValidation = void 0;
const PaymentTransactionValidation_1 = require("./PaymentTransactionValidation");
class PaymentTerminalControlPresentedPaymentsValidation {
    static isValid(entity) {
        // Validate entity.payments for existence and correct type.
        if (entity.payments == undefined)
            return false;
        if (!Array.isArray(entity.payments))
            return false;
        if (!entity.payments.every((elem) => {
            if (!PaymentTransactionValidation_1.PaymentTransactionValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.PaymentTerminalControlPresentedPaymentsValidation = PaymentTerminalControlPresentedPaymentsValidation;
